import axiosInstance from "./AxiosInstance";

export function getCompanyData(data) {
    return axiosInstance.post(`company`, data);
}

export function checkVisitor(data) {
    return axiosInstance.post(`increment-visitor`, data);
}

export function subscribe(data) {
    return axiosInstance.post(`subscribe`, data);
}